PJQ.templating = {
	templates: {}
};

PJQ.templating.Template = class {
	constructor(module, file, options = {}) {
		this.module = module;
		this.file = file;
		this.options = _.defaults(options, {
			isOldModule: false
		});
	}

	getPath() {
		let path;
		if (PJQ.app.options.isCombinedAssets) {
			path = PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'assets'
				},
				{
					endpoint: 'layout',
					value: this.module
				},
				{
					endpoint: this.file + '.tmpl.html' + '?v=' + (this.options.isOldModule ? PJQ.app.version : PJQ.app.version)
				}
			]);
		}
		else {
			path = PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'assets'
				},
				{
					endpoint: this.options.isOldModule ? 'modules' : 'modules2'
				},
				{
					endpoint: this.module
				},
				{
					endpoint: 'layout'
				},
				{
					endpoint: this.file + '.tmpl.html' + '?v=' + (this.options.isOldModule ? PJQ.app.version : PJQ.app.version)
				}
			]);
		}

		if (PJQ.app.options.isK8) {
			path = path.toLowerCase();
		}

		return _.size(PJQ.app.options.cdnUrl) > 0 ? (PJQ.app.options.cdnUrl + path) : PJQ.helpers.urlHelpers.buildDomainURL(path, false);
	}

	fetch(callback) {
		let url = this.getPath();
		if (PJQ.templating.TemplateRenderer.templates[url]) {
			let cachedTemplate = PJQ.templating.TemplateRenderer.templates[url];
			this.parse(cachedTemplate);
			if (typeof callback === 'function')
				callback(cachedTemplate);
			//todo: phase out this return - this is only here to support methods that call this synchronously
			return cachedTemplate;
		}
		else {
			$.ajax({
				url: url,
				method: 'GET',
				dataType: 'html',
				success: _.bind(function (html) {
					// html = '<div>' + html + '</div>';
					let template = {
						template: _.template(html),
						markup: html,
						jsRenderTemplate: typeof $.templates === 'function' ? $.templates(html) : null
					};
					this.parse(template);
					PJQ.templating.TemplateRenderer.templates[url] = template;
					if (typeof callback === 'function')
						callback(template);
				}, this)
			});
		}
	}

	parse(template) {
		this.template = template.template;
		this.markup = template.markup;
		this.jsRenderTemplate = template.jsRenderTemplate;
	}

	render(data, callback) {
		this.fetch(_.bind(function (template) {
			if (typeof callback === 'function') {
				if (this.options.isJsRender) {
					callback($(template.jsRenderTemplate.render(data)));
				}
				else {
					callback($(template.template(data ? data : {})));
				}
			}
		}, this));
	}
};

PJQ.templating.TemplateRenderer = {
	templates: {},
	renderTemplate: function (isAppend, tmpl, $el, data, callback, options = {}) {
		this.parseTemplate(tmpl, data, _.bind(function (template) {
			this.render(isAppend, template, $el, callback, options);
		}, this));
	},
	parseTemplate: function (tmpl, data, callback, options) {
		let template = $();
		if (tmpl instanceof $) {
			template = $(_.template(tmpl.html())(data ? data : {}));
			if (typeof callback === 'function')
				callback(template);
			//todo: phase out this return - this is only here to support methods that call this synchronously
			return template;
		}
		else if (tmpl instanceof PJQ.templating.Template) {
			if (this.templates[tmpl.getPath()]) {
				tmpl.render(data, callback);
				//todo: phase out this return - this is only here to support methods that call this synchronously
				return $(tmpl.fetch().template(data ? data : {}));
			}
			else {
				tmpl.render(data, callback);
			}
		}
		else if (typeof tmpl === 'string') {
			if (!this.templates[tmpl]) {
				let html = '<div>' + $('#' + tmpl).html() + '</div>';
				this.templates[tmpl] = {
					template: _.template(html),
					markup: html
				};
			}
			template = $(this.templates[tmpl].template(data ? data : {}));
			if (typeof callback === 'function')
				callback(template);
			//todo: phase out this return - this is only here to support methods that call this synchronously
			return template;
		}
		else {
			if (typeof callback === 'function')
				callback(template);
			//todo: phase out this return - this is only here to support methods that call this synchronously
			return template;
		}
	},
	fetchTemplates: function (templates, callback) {
		let templateCount = _.size(_.filter(templates, function (template) {
			return template instanceof PJQ.templating.Template;
		}));
		if (templateCount === 0) {
			callback();
		}
		else {
			let resultCount = 0,
				resultCallback = function () {
					resultCount++;
					if (resultCount === templateCount)
						callback();
				};
			_.each(templates, function (template) {
				if (template instanceof PJQ.templating.Template)
					template.fetch(resultCallback);
			});
		}
	},
	parseMarkup: function (markup, data) {
		return $(_.template('<div>' + markup + '</div>')(data ? data : {})).html();
	},
	render: function (isAppend, content, $el, callback, options) {
		if(options && options.prepend)
			$el.prepend(content);
		else if(options && options.replace)
			$el.replaceWith(content);
		else if (isAppend)
			$el.append(content);
		else
			$el.html(content);
		if (typeof callback === 'function')
			callback(content);
	}
};